module.exports = __webpack_public_path__ + "img/logo.e183eff6.png";